// extracted by mini-css-extract-plugin
export default {"table":"Doc_table__1UvBi","form_control_label":"Doc_form_control_label__+RpZ6"};